<template>
  <div
    class="absolute top-0 left-0 flex justify-center w-full h-full p-2 overflow-auto"
    >
    <div class="flex flex-col w-full h-full divide-y rounded-md">
      <ProfileUserInfo />
      <ProfilePassword :userId="userId" />
    </div>
  </div>
</template>

<script>
import ProfilePassword from "./components/ProfilePassword.vue";
import ProfileUserInfo from "./components/ProfileUserInfo.vue";
import { getLoginUserId } from "@/plugins/shared.js";

export default {
  name: "ProfileLayout",
  data() {
    return {
      userId: "",
    };
  },
  components: {
    ProfileUserInfo,
    ProfilePassword,
  },
  mounted() {
    this.userId = getLoginUserId();
  },
};
</script>

<style lang="scss" scoped></style>
